import { store } from '@common/store/store';
import { sDs } from '@common/sDs/sDs';
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";

let ddStoreFilter = function (value, cId) {
    if (!cId) cId = 'control';
    if (typeof value === 'string') {
        const regexp = /DD\.([^ .]+)\.([^ .]+)/gm;
        let matches;
        let useMatch = typeof value.matchAll === 'undefined';
        if (useMatch) {
            matches = value.match(regexp);
        } else {
            matches = value.matchAll(regexp);
        }
        let tmpValue = library.cloneObj(value);
        for (let match of matches) {
            if (useMatch) {
                match = match.split('.');
            }
            let group = match[1];
            let labelId = match[2];
            // eslint-disable-next-line no-use-before-define
            if (ddStore.state.availableGroups.indexOf(group) !== -1) {
                // eslint-disable-next-line no-use-before-define
                if (typeof tmpValue === 'string' && typeof tmpValue.replaceAll === 'function') tmpValue = tmpValue.replaceAll(match[0], ddStore.state.records[cId][group][labelId]);
            }
        }
        value = library.cloneObj(tmpValue);
    }
    if (typeof value === 'object') {
        let flattenValue = library.flatten(value);
        let useDDPaths = Object.keys(flattenValue).filter((key) => typeof flattenValue[key] === 'string' && flattenValue[key].indexOf('DD.') !== -1 && key.indexOf('controls') === -1 && key.indexOf('cTemplate') === -1);
        if (useDDPaths.length) {
            for (let i in useDDPaths) {
                if (i === 'length') continue;
                let stringToTranslate = library.getByPath(value, useDDPaths[i], '');
                let useMatch = typeof stringToTranslate.matchAll === 'undefined';
                const regexp = /DD\.([^ .]+)\.([^ .]+)/gm;
                let matches;
                if (useMatch) {
                    matches = stringToTranslate.match(regexp);
                } else {
                    matches = stringToTranslate.matchAll(regexp);
                }
                for (let match of matches) {
                    if (useMatch) {
                        match = match.split('.');
                    }
                    let group = match[1];
                    let labelId = match[2];
                    // eslint-disable-next-line no-use-before-define
                    if (ddStore.state.availableGroups.indexOf(group) !== -1) {
                        // eslint-disable-next-line no-use-before-define
                        if (ddStore.state.records[cId][group][labelId] !== '') {
                            // eslint-disable-next-line no-use-before-define
                            stringToTranslate = stringToTranslate.replaceAll(match[0], ddStore.state.records[cId][group][labelId]);
                            library.setByPath(value, useDDPaths[i], stringToTranslate);
                        } else {
                            return [];
                        }
                    }
                }
            }
        }
    }
    return value;
};

let ddStore = {
    namespaced: true,
    state: {
        records: {},
        requests: {},
        loading: false,
        recordLastRequests: {},
        componentItems: {},
        itemComponents: {},
        availableGroups: [
            'SHARERECORD', 'PROMOTERECORD', 'COMMON', 'AMS', 'MEMBER', 'VOLUNTEER', 'OPPORTUNITY', 'CAMPAIGN', 'ORGANIZATION', 'FILTER', 'SCHEDULING', 'REPORT',
            'PLACEMENT', 'LOGBOOK', 'EMAIL', 'HOMEBASE', 'EXCHANGE', 'DATA_GRID', 'ATTRIBUTEMANAGER', 'SCHEDULE_CALENDAR',
            'CUSTOM_ATTRIBUTE', "RMS", 'COORD_MENU', 'RECRUITER', 'FORGOTPASSWORD', 'ADMIN_OPTIONS', 'SIGNIN_OPTIONS', 'SIGNIN2_OPTIONS', 'CLIENT_OPTIONS', 'SIGNIN', 'APPROVER', 'ATTACHMENT', 'HISTORY', 'BACKGROUND_CHECK', 'EULA'
        ]
    },
    getters: {
        preloadGroup(state) {
            return function (payload) {
                let [group] = Object.values(payload);
                let label = 'PRELOAD';
                return new Promise((resolve) => {
                    // eslint-disable-next-line no-unused-expressions
                    ddStore.state.records['alerts']; // NOSONAR
                    // eslint-disable-next-line no-unused-expressions
                    ddStore.state.records['alerts'][group]; // NOSONAR
                    // eslint-disable-next-line no-new-func
                    let prevWatchers = typeof state.records[group]._watcher === 'function' ? state.records[group]._watcher : function () {};
                    state.records[group]._watcher = () => {
                        let message = ddStore.state.records['alerts'][group][label];
                        prevWatchers();
                        resolve(message);
                    };
                    let message = ddStore.state.records['alerts'][group][label];
                    if (message) resolve(message);
                });
            };
        },
        getAlias(state) {
            return function (payload) {
                let [group, label, ...args] = Object.values(payload);
                let applyArgs = (message, messageArgs) => {
                    let tmpMessage = message;
                    for (let i in messageArgs) {
                        if (i === 'length') continue;
                        let index = parseInt(i, 10) + 1;
                        tmpMessage = tmpMessage.replace('%' + index + '!', ' ' + messageArgs[i] + ' ');
                    }
                    tmpMessage = tmpMessage.replace('  ', ' ');
                    return tmpMessage;
                };
                return new Promise((resolve) => {
                    // eslint-disable-next-line no-unused-expressions
                    ddStore.state.records['alerts']; // NOSONAR
                    // eslint-disable-next-line no-unused-expressions
                    ddStore.state.records['alerts'][group]; // NOSONAR
                    state.records[group]._watcher = () => {
                        let message = ddStore.state.records['alerts'][group][label];
                        resolve(applyArgs(message, args));
                    };
                    let message = ddStore.state.records['alerts'][group][label];
                    if (message) resolve(applyArgs(message, args));
                });
            };
        },
        getAliasSync(state) {
            return function (payload) {
                let [group, label, ...args] = Object.values(payload);
                let applyArgs = (message, messageArgs) => {
                    let tmpMessage = message;
                    for (let i in messageArgs) {
                        if (i === 'length') continue;
                        let index = parseInt(i, 10) + 1;
                        tmpMessage = tmpMessage.replace('%' + index + '!', ' ' + messageArgs[i] + ' ');
                    }
                    tmpMessage = tmpMessage.replace('  ', ' ');
                    return tmpMessage;
                };
                let message = ddStore.state.records['alerts'][group][label];
                if (message) return applyArgs(message, args);
                return 'DD.' + group + '.' + label;
            };
        },
        // getRecords called each time component trying to get label
        getRecords(state) {
            return function (payload) {
                let [group, labels, force] = Object.values(payload);
                let removeLabels = (labelId) => {
                    if (state.records && state.records[group] && state.records[group][labelId] && (state.records[group][labelId].requestTimestamp || state.records[group][labelId].notFound)) {
                        labels.splice(labels.indexOf(labelId), 1); // NOSONAR
                    }
                };
                // check if there were no previous request for the same group and labelId
                if (state.requests[group] && state.requests[group].timeout) {
                    // if there was request with the same group and labelId in last 500ms
                    // we should stop the request
                    clearTimeout(state.requests[group].timeout);

                    // append the labels from the previous request to the current
                    labels = [...labels, ...state.requests[group].labels].filter(library.arrayUnique);
                }
                // and check if some of labels were already loaded
                if (!force) {
                    let tmpLabels = library.cloneObj(labels);
                    for (let i in tmpLabels) {
                        if (i === 'length') continue;
                        // remove already loaded labels from the request
                        removeLabels(tmpLabels[i]);
                    }
                }
                if (!labels.length) return;
                if (typeof state.requests[group] === 'undefined') state.requests[group] = {};
                // save the current request and get label data
                state.requests[group].labels = labels;
                state.requests[group].timeout = setTimeout(async () => {
                    state.loading = true;
                    let postRequest = sDs.post('er_getDisplayLabels', group);
                    postRequest.then((response) => {
                        delete state.requests[group];
                        let timestamp = Math.floor(Date.now() / 1000); // NOSONAR
                        if (response.status === 'success' && response.data) {
                            let tmp = library.cloneObj(ddStore.state.records);
                            for (let i in response.data) {
                                if (i === 'length') continue;
                                let labelName = response.data[i].NAME;
                                if (typeof tmp[group] === 'undefined') tmp[group] = {};
                                if (typeof tmp[group][labelName] === 'undefined') tmp[group][labelName] = {};
                                tmp[group][labelName] = response.data[i];
                                delete tmp[group][labelName].notFound;
                                tmp[group][labelName].requestTimestamp = Math.floor(Date.now() / 1000); // NOSONAR
                            }
                            for (let i in labels) {
                                if (i === 'length') continue;
                                if (tmp?.[group]?.[labels[i]] && typeof tmp[group][labels[i]].requestTimestamp === 'undefined') {
                                    tmp[group][labels[i]].ALIAS = 'DD.' + group + '.' + labels[i];
                                    tmp[group][labels[i]].notFound = true;
                                }
                            }
                            // eslint-disable-next-line no-use-before-define
                            ddStore.state['records'] = new Proxy(tmp, componentHandler);
                            ddStore.watcher(group);
                        }
                        state.recordLastRequests[group] = timestamp;
                        setTimeout(() => {
                            state.loading = false;
                        }, 500);
                    });
                }, 1000); // NOSONAR
            };
        }
    },
    actions: {
        watcher({ state, commit, dispatch }, payload) {
            let [group] = Object.values(payload);
            if (state.records[group] && state.records[group]._watcher) {
                state.records[group]._watcher();
            }
        },
        // remove unused items from the ddStore
        // called in component destroyed function
        removeUnusedItems({ state, commit, dispatch }, payload) {
            let [componentId] = Object.values(payload);
            // check existance of component
            if (state.componentItems[componentId]) {
                // go through the all component labels that were loaded
                for (let i in state.componentItems[componentId]) {
                    if (i === 'length') continue;
                    let item = state.componentItems[componentId][i];
                    if (state.itemComponents[item]) {
                        // check if this label was loaded only for current component
                        if (state.itemComponents[item].length === 1 && state.itemComponents[item][0] === componentId) { // NOSONAR
                            let path = item.split('["');
                            for (let j in path) {
                                if (j === 'length') continue;
                                path[j] = path[j].replace('"]', '');
                            }
                            let group = path[0]; // NOSONAR
                            let labelId = path[1]; // NOSONAR

                            delete state.records[group][labelId];

                            // remove whole group if all records were removed
                            if (library.objIsEmpty(state.records[group])) {
                                delete state.records[group];
                            }
                            delete state.itemComponents[item];
                        } else {
                            state.itemComponents[item].splice(state.itemComponents[item].indexOf(componentId), 1); // NOSONAR
                        }
                    }
                }
                delete state.componentItems[componentId];
            }
        }
    }
};

// catch all nested properties and returns the proxy e.g. this.ddStore.GROUP_NAME || this.ddStore.GROUP_NAME.LABEL_NAME
let recordHandler = {
    get(target, prop) {
        // js exceptions that should not be under the proxy
        if (prop !== Symbol.toStringTag && prop !== Symbol.toPrimitive) {
            let obj = {};
            // check what property was called
            if (target.group) {
                // e.g. this.ddStore.GROUP_NAME.LABEL_NAME
                obj.component = target.component;
                obj.group = target.group;
                obj.labelId = prop;
            } else if (target.component) {
                // e.g. this.ddStore.GROUP_NAME
                obj.component = target.component;
                obj.group = prop;
            }

            // if label alias is called e.g. this.ddStore.GROUP_NAME.LABEL_NAME
            if (obj.labelId) {
                if (typeof ddStore.state.records[obj.group][obj.labelId] === 'undefined') {
                    let timestamp = Math.floor(Date.now() / 1000); // NOSONAR
                    ddStore.state.records[obj.group][obj.labelId] = { ALIAS: '', initialized: timestamp };
                    // write which labels used this component
                    if (typeof ddStore.state.componentItems[obj.component] === 'undefined') {
                        ddStore.state.componentItems[obj.component] = [];
                    }
                    if (ddStore.state.componentItems[obj.component].indexOf(obj.group + '["' + obj.labelId + '"]') === -1) {
                        ddStore.state.componentItems[obj.component].push(obj.group + '["' + obj.labelId + '"]');
                    }
                    // write which components use this label
                    if (typeof ddStore.state.itemComponents[obj.group + '["' + obj.labelId + '"]'] === 'undefined') {
                        ddStore.state.itemComponents[obj.group + '["' + obj.labelId + '"]'] = [];
                    }
                    if (ddStore.state.itemComponents[obj.group + '["' + obj.labelId + '"]'].indexOf(obj.component) === -1) {
                        ddStore.state.itemComponents[obj.group + '["' + obj.labelId + '"]'].push(obj.component);
                    }
                    // call sDs for getting data from server
                    ddStore.getRecords(obj.group, [obj.labelId]);
                }
                // return the link to the ddStore
                return ddStore.state.records[obj.group][obj.labelId].ALIAS;
            }
            // if not label alias was called
            if (obj.group && typeof ddStore.state.records[obj.group] === 'undefined') {
                ddStore.state.records[obj.group] = {};
            }
            if (obj.labelId && typeof ddStore.state.records[obj.group][obj.labelId] === 'undefined') {
                ddStore.state.records[obj.group][obj.labelId] = {};
            }
            // return the proxy
            return new Proxy(obj, recordHandler);
        }
        // following code needed to js for right render object to a string
        if (prop === Symbol.toPrimitive) {
            let res;
            if (target.labelId) {
                res = ddStore.state.records[target.group][target.labelId];
            } else if (target.group) {
                res = ddStore.state.records[target.group];
            }
            return (hint) => {
                if (res && hint === 'string') {
                    return JSON.stringify(res);
                }
                return null;
            };
        }
        return target.toString();
    },
    set(target, prop, val) {
        // save the value of label if this.ddStore.GROUP_NAME.LABEL_NAME = 'Name'; was called
        let tmp = library.cloneObj(ddStore.state.records);
        if (target.component && target.group) {
            tmp[target.group][prop].ALIAS = val;
        } else {
            tmp[prop] = val;
        }
        // eslint-disable-next-line no-use-before-define
        ddStore.state['records'] = new Proxy(tmp, componentHandler);
        return true;
    }
};

// catch componentId when this.ddStore[this.cId] called from the component
let componentHandler = {
    get(target, prop) {
        // check existance of component in the componentStore
        if (!target.component && ((componentStore && componentStore.state && componentStore.state.components && componentStore.state.components[prop]) || prop === 'control' || prop === 'alerts')) {
            let obj = {
                component: prop
            };
            return new Proxy(obj, recordHandler);
        }
        return target[prop];
    }
};
ddStore.state.records = new Proxy(ddStore.state.records, componentHandler);

store.registerModule('ddStore', ddStore);
export { ddStore, ddStoreFilter };
